import { render, staticRenderFns } from "./TotalAmountView.vue?vue&type=template&id=1e51dcbc&scoped=true"
import script from "./TotalAmountView.vue?vue&type=script&lang=js"
export * from "./TotalAmountView.vue?vue&type=script&lang=js"
import style0 from "./TotalAmountView.vue?vue&type=style&index=0&id=1e51dcbc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e51dcbc",
  null
  
)

export default component.exports